module.exports = __webpack_public_path__ + "img/estebangrimalt.b0165962.jpg";